// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Tesamorelin Initial (systemic) 09.17.26" (050113f6-1c52-4b0b-b93f-69948293e9ac). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiTesamorelinInitialSystemicAnswerField } from './questions';

export const mdiTesamorelinInitialSystemic: FormType<mdiTesamorelinInitialSystemicAnswerField> =
  {
    name: 'Tesamorelin Initial (systemic)',
    validityLength: 25,
    questions: [
      'mdiTesamorelinInitialSystemic_symptoms',
      {
        key: 'mdiTesamorelinInitialSystemic_injuriesSurgeriesWithinLast6',
        next: {
          condition: {
            'mdiTesamorelinInitialSystemic_injuriesSurgeriesWithinLast6.yes':
              true
          },
          key: 'mdiTesamorelinInitialSystemic_describeSurgeryInjuryApproximateDate',
          els: 'mdiTesamorelinInitialSystemic_apply'
        }
      },
      'mdiTesamorelinInitialSystemic_describeSurgeryInjuryApproximateDate',
      {
        key: 'mdiTesamorelinInitialSystemic_apply',
        next: {
          switch: [
            {
              condition: { 'mdiTesamorelinInitialSystemic_apply.glioma': true },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueMedicalConditions'
            },
            {
              condition: {
                'mdiTesamorelinInitialSystemic_apply.any_other_type_of_cancer_or_tumor':
                  true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueMedicalConditions'
            }
          ],
          els: 'mdiTesamorelinInitialSystemic_takeMedications'
        }
      },
      'mdiTesamorelinInitialSystemic_imSorryDueMedicalConditions',
      {
        key: 'mdiTesamorelinInitialSystemic_takeMedications',
        next: {
          switch: [
            {
              condition: {
                'mdiTesamorelinInitialSystemic_takeMedications.clonidine_or_levodopa':
                  true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentMedications'
            },
            {
              condition: {
                'mdiTesamorelinInitialSystemic_takeMedications.octreotide_lanreotide_or_pasireotide':
                  true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentMedications'
            },
            {
              condition: {
                'mdiTesamorelinInitialSystemic_takeMedications.glucocorticoids_such_as_prednisone_dexam':
                  true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentMedications'
            }
          ],
          els: 'mdiTesamorelinInitialSystemic_apply2'
        }
      },
      'mdiTesamorelinInitialSystemic_imSorryDueCurrentMedications',
      {
        key: 'mdiTesamorelinInitialSystemic_apply2',
        next: {
          switch: [
            {
              condition: {
                'mdiTesamorelinInitialSystemic_apply2.i_binge_drink_4_or_more_alcoholic_drinks':
                  true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentAlcohol'
            },
            {
              condition: {
                'mdiTesamorelinInitialSystemic_apply2.i_take_opiates_prescription_or_recreatio':
                  true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentAlcohol'
            },
            {
              condition: {
                'mdiTesamorelinInitialSystemic_apply2.both_apply_to_me': true
              },
              key: 'mdiTesamorelinInitialSystemic_imSorryDueCurrentAlcohol'
            }
          ],
          els: 'mdiTesamorelinInitialSystemic_lastTimePersonMedicalEvaluation'
        }
      },
      'mdiTesamorelinInitialSystemic_imSorryDueCurrentAlcohol',
      'mdiTesamorelinInitialSystemic_lastTimePersonMedicalEvaluation',
      'mdiTesamorelinInitialSystemic_firstMessageDoctor',
      'mdiTesamorelinInitialSystemic_complete'
    ]
  };
